const userRolesEnum = [
  { id: 1, value: 'Super admin' },
  { id: 2, value: 'Admin' },
  { id: 3, value: 'Branch' },
  { id: 4, value: 'Company admin' }
];

export default { userRolesEnum };
